module.exports={
	"Hash": "high-contrast",
	"Name": "High Contrast",
	"Version": "1.0.0",
	"Description": "Maximum-contrast pair for legibility: black and white with a single bright ink and heavy borders.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#000000"
				},
				"Secondary": {
					"Light": "#f2f2f2",
					"Dark": "#0a0a0a"
				},
				"Tertiary": {
					"Light": "#e8e8e8",
					"Dark": "#141414"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#000000"
				},
				"Hover": {
					"Light": "#ededed",
					"Dark": "#1a1a1a"
				},
				"Selected": {
					"Light": "#bcd0ff",
					"Dark": "#16357a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#ffffff"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#e8e8e8"
				},
				"Muted": {
					"Light": "#333333",
					"Dark": "#c8c8c8"
				},
				"Placeholder": {
					"Light": "#666666",
					"Dark": "#9a9a9a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				},
				"PrimaryHover": {
					"Light": "#0026d6",
					"Dark": "#fff15a"
				},
				"Accent": {
					"Light": "#c00000",
					"Dark": "#00e5ff"
				}
			},
			"Border": {
				"Light": "#000000",
				"Dark": "#ffffff"
			},
			"Status": {
				"Success": {
					"Light": "#0a7a2f",
					"Dark": "#00e676"
				},
				"Warning": {
					"Light": "#9a6500",
					"Dark": "#ffc400"
				},
				"Error": {
					"Light": "#c00000",
					"Dark": "#ff453a"
				},
				"Info": {
					"Light": "#0b34ff",
					"Dark": "#00e5ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f2f2f2",
					"Dark": "#0a0a0a"
				},
				"Thumb": {
					"Light": "#000000",
					"Dark": "#ffffff"
				},
				"Hover": {
					"Light": "#333333",
					"Dark": "#c8c8c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
